export const breakpoints = {
	s: "600",
	m: "900",
	l: "1100"
};

export default {
	breakpoints
};